<app-basic-card>
    <app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
    <div class="d-flex justify-content-start">
        <button mat-button color="warn" [disabled]="isReadOnly" (click)="reset()">{{'reset' | uppercase}}</button>
    </div>
</app-basic-card>